<script>
// <ajax-panel src="/static/examples/html.html" inline-template>
// <div :class="['ajax-panel']">
//   <pre>{{ template }}</pre>
// </div>
// </ajax-panel>
//
// <ajax-panel src="/static/examples/json.json" inline-template>
// <div :class="['ajax-panel']">
//   <h1>{{ template.name }} (JSON template)</h1>
// <ul>
// <li v-for="(item, index) in template.someArray" :key="index">
//   {{ item }}
// </li>
// </ul>
// </div>
// </ajax-panel>
export default {
  name: 'AjaxPanel',
  data () {
    return {
      template: {}
    }
  },
  props: {
    src: {
      type: String,
      required: true
    }
  },
  mounted () {
    const events = this.$store.state.events
    const root = this.$root
    root.$emit(events.exampleLoading)
    this.$http(this.src).then(response => {
      this.template = response.data
      root.$emit(events.exampleLoaded)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ajax-panel/AjaxPanel.vue